// eslint-disable-next-line import/no-default-export
export default async function copy(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Previous implementation also just silently caught errors. This could potentially raise a flag instead
    return false;
  }
}
